import type { PanoramaImage } from '@state/panorama.ts'

export interface GraphPoint {
  connectedPoints: PanoramaImage[]
  point: PanoramaImage
}

class GraphBuilder {
  private graphMap: Map<string, GraphPoint>

  constructor() {
    this.graphMap = new Map()
  }

  getOrCreateGraphPoint(point: PanoramaImage): GraphPoint {
    let graphPoint = this.graphMap.get(point.id)
    if (!graphPoint) {
      graphPoint = { point, connectedPoints: [] }
      this.graphMap.set(point.id, graphPoint)
    }
    return graphPoint
  }

  addBidirectionalConnection(point1: PanoramaImage, point2: PanoramaImage): void {
    const graphPoint1 = this.getOrCreateGraphPoint(point1)
    const graphPoint2 = this.getOrCreateGraphPoint(point2)

    // Add bidirectional connections (avoid duplicates)
    if (!graphPoint1.connectedPoints.some(p => p.id === point2.id)) {
      graphPoint1.connectedPoints.push(point2)
    }
    if (!graphPoint2.connectedPoints.some(p => p.id === point1.id)) {
      graphPoint2.connectedPoints.push(point1)
    }
  }

  toArray(): GraphPoint[] {
    return Array.from(this.graphMap.values())
  }
}

export default GraphBuilder